var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmailShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 0.375H6.75C3 0.375 0.5 2.25 0.5 6.625V15.375C0.5 19.75 3 21.625 6.75 21.625H19.25C23 21.625 25.5 19.75 25.5 15.375V6.625C25.5 2.25 23 0.375 19.25 0.375ZM19.8375 7.9875L15.925 11.1125C15.1 11.775 14.05 12.1 13 12.1C11.95 12.1 10.8875 11.775 10.075 11.1125L6.1625 7.9875C5.7625 7.6625 5.7 7.0625 6.0125 6.6625C6.3375 6.2625 6.925 6.1875 7.325 6.5125L11.2375 9.6375C12.1875 10.4 13.8 10.4 14.75 9.6375L18.6625 6.5125C19.0625 6.1875 19.6625 6.25 19.975 6.6625C20.3 7.0625 20.2375 7.6625 19.8375 7.9875Z",
    fill: "#95308A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email-share.8fed1808.svg";
export { ForwardRef as ReactComponent };